module.exports = "pegasus_template/assets/background-patterns/mocha-grunge.png";